import * as React from 'react';
import { styled } from '@linaria/react';
import { Play, Pause } from 'lucide-react';

import usePrefersReducedMotion from '@/hooks/use-prefers-reduced-motion';

import Space from '@/components/Space';
import ButtonPlayful from '@/components/ButtonPlayful';
import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';

function TheProblem({}) {
  const [playState, setPlayState] = React.useState('running');

  const prefersReducedMotion = usePrefersReducedMotion();

  React.useEffect(() => {
    setPlayState(prefersReducedMotion ? 'paused' : 'running');
  }, [prefersReducedMotion]);

  return (
    <Demo
      initialValues={{
        mode: 'default',
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr' }}
      outputWrapper={null}
      controls={[
        <DemoToggleButtonGroupControl
          inline
          key="mode"
          id="mode"
          label=""
          options={[
            {
              label: 'Default',
              value: 'default',
            },
            {
              label: 'Tweaked',
              value: 'fixed',
            },
          ]}
        />,
      ]}
    >
      {({ mode }) => {
        return (
          <>
            <Wrapper>
              <Header>
                {mode === 'default' ? (
                  <GlassyBackdrop />
                ) : (
                  <FixedGlassyBackdrop />
                )}
              </Header>
              <BouncingBall
                style={{ animationPlayState: playState }}
              />
            </Wrapper>
            <Actions>
              <Button
                Icon={playState === 'running' ? Pause : Play}
                backgroundColor="hsl(175deg 60% 25%)"
                highlightColor="hsl(168deg 70% 35%)"
                onClick={() =>
                  setPlayState(
                    playState === 'running' ? 'paused' : 'running'
                  )
                }
              >
                Play/Pause Animation
              </Button>
            </Actions>
          </>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  isolation: isolate;
  border: 1px solid var(--color-content-outline);
`;

const Header = styled.div`
  position: relative;
  height: 100px;
  width: 100%;
  z-index: 2;
`;

const GlassyBackdrop = styled.div`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(24px);
  background: hsl(0deg 0% 100% / 0.1);
  pointer-events: none;
`;

const FixedGlassyBackdrop = styled(GlassyBackdrop)`
  height: 200%;
  mask-image: linear-gradient(
    to bottom,
    black 0,
    black 50%,
    transparent 50%
  );
`;

const BouncingBall = styled.div`
  --size: 128px;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background: hsl(45deg 100% 50%);
  animation: bounce 1000ms alternate infinite ease-in-out;

  @keyframes bounce {
    0% {
      transform: translateY(-20px);
    }

    100% {
      transform: translateY(20px);
    }
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
`;

const Button = styled(ButtonPlayful)`
  outline: 1px solid var(--color-gray-200);
`;

export default TheProblem;
